import { render, staticRenderFns } from "./LabelContractsReservesEditPanel.vue?vue&type=template&id=e115ed5a"
import script from "./LabelContractsReservesEditPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsReservesEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports